import React, { useState, useEffect, useRef, useContext } from "react";
import { Context } from "../providers/mainProvider";
import { useNavigate } from "react-router-dom";
import { userLogin, verifyOtp } from "../services/authService";
import mountainsBg from "../assets/images/mountains-bg.webp";
import Cookies from "./cookies";

const VerificationComponent = () => {
  const { setValue } = useContext(Context);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(25);
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const username = localStorage.getItem("username");

  useEffect(() => {
    if (inputRefs.current[0]) inputRefs.current[0].focus();

    const interval = setInterval(() => {
      setTimer((prev) => (prev <= 1 ? (clearInterval(interval), 0) : prev - 1));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) inputRefs.current[index + 1]?.focus();
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (otp.join("").length !== 6) {
      alert("Please enter a valid 6-digit OTP.");
      return;
    }

    try {
      const response = await verifyOtp(username, otp.join(""));
      console.log("OTP Verification Response:", response);

      // The actual data is probably in response.data directly
      const data = response.data || response;

      if (data && data.status) {
        const { access_token, role, username } = data;  // use 'role' and 'username' from your API response

        setValue({
          auth: true,
          access_token,
          user_role: role,
          user_name: username,  // if username is your unique id substitute for uuid
        });

        localStorage.setItem(
          "user",
          JSON.stringify({
            user_role: role,
            user_name: username,
            access_token,
          })
        );

        const CookieObj = new Cookies();
        CookieObj.setCookieBatch([
          {
            name: "access_token",
            value: access_token,
            days: 7,
          },
        ]);

        if ((role || "").toLowerCase() === "admin") {
          navigate("/user-details/");
        } else {
          navigate("/environment-data/");
        }
      } else {
        alert("Invalid OTP, please try again.");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      alert("An error occurred verifying OTP. Please try again later.");
    }
  };



  const handleResend = async () => {
    alert("Resend OTP clicked");

    if (!username) {
      alert("No username found. Please log in again.");
      return;
    }

    try {
      // Trigger resend OTP API call
      const response = await userLogin(username);
      console.log("Resend OTP Response:", response);

      if (response && response.success) {
        setOtp(["", "", "", "", "", ""]);
        setTimer(25);
        inputRefs.current[0]?.focus();
      } else {
        alert("Failed to resend OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error resending OTP:", error);
      alert("An error occurred. Please try again later.");
    }
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-teal-300 via-teal-400 to-emerald-500 flex items-center justify-center p-4 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${mountainsBg})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-[#0F977E]/90 via-[#0F977E]/40 to-[#03251F]/100"></div>
      </div>

      <div className="w-full max-w-[650px] xxl:max-w-[500px] bg-white rounded-3xl shadow-2xl p-8 sm:p-12 relative z-10 bg-white/80">
        <div className="flex justify-center mb-8">
          <img width="150" height="40" alt="CIEMS" src="/images/logo.png" />
        </div>

        <div className="text-center mb-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
            Verification
          </h2>
          <p className="text-gray-600 text-sm sm:text-base">
            We sent a code to your registered email address.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="flex justify-center gap-2 sm:gap-3 mb-6">
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                type="text"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                className="w-10 input-form-field h-10 sm:w-12 sm:h-12 text-center text-xl font-semibold border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-all"
              />
            ))}
          </div>

          <button
            type="submit"
            disabled={otp.some((digit) => !digit)}
            className="common-btn w-full"
          >
            Continue
          </button>
        </form>

        <div className="text-center mt-6">
          <p className="text-gray-700 font-semibold text-lg">{formatTime(timer)}</p>
        </div>

        <div className="text-center mt-4">
          <p className="text-gray-600 text-sm">
            Didn't receive the email?{" "}
            <button
              type="button"
              onClick={handleResend}
              className="text-teal-600 hover:text-teal-700 font-semibold hover:underline"
            >
              Resend
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerificationComponent;
